import { createContext } from "react";

// Creación de Context para su posterior configuración propia del cliente para la aplicación
export const LinkActiveContext = createContext(null);
